import request from '@/utils/request';

// VIP质检-质检列表
export function getInspectionList(data) {
  return request({
    url: '/admin/get_inspection_list',
    method: 'get',
    params: data,
  });
}
// VIP质检-获取质检列表下拉框
export function getInspectionSelect(data) {
  return request({
    url: '/admin/get_inspection_select',
    method: 'get',
    params: data,
  });
}
// VIP质检-质检详情
export function getInspectionInfo(data) {
  return request({
    url: '/admin/get_inspection_info',
    method: 'get',
    params: data,
  });
}
// VIP质检-获取来访列表
export function getInspectionChatList(data) {
  return request({
    url: '/admin/get_inspection_chat_list',
    method: 'get',
    params: data,
  });
}
// VIP质检-提交质检结果
export function saveCheckResult(data) {
  return request({
    url: '/admin/save_check_result',
    method: 'put',
    params: data,
  });
}
// VIP质检-获取时间设置
export function getConfigSetting(data) {
  return request({
    url: '/admin/get_config_setting',
    method: 'get',
    params: data,
  });
}
// VIP质检-设置时间
export function setConfigSetting(data) {
  return request({
    url: '/admin/set_config_setting',
    method: 'post',
    data,
  });
}

// VIP质检-客服昵称关联表
export function getDutyList(data) {
  return request({
    url: '/admin/get_duty_list',
    method: 'get',
    params: data,
  });
}
// VIP质检-保存关联关系
export function saveDutyData(data) {
  return request({
    url: '/admin/save_duty_data',
    method: 'put',
    data,
  });
}

// VIP质检-上传excel列表
export function getInspectionUpload(data) {
  return request({
    url: '/admin/get_inspection_upload',
    method: 'get',
    params: data,
  });
}
// VIP质检-上传excel
export function saveInspectionUploadPost(data) {
  return request({
    url: '/admin/save_inspection_upload',
    method: 'post',
    data,
  });
}
// VIP质检-删除excel
export function deleteInspectionUpload(data) {
  return request({
    url: '/admin/delete_inspection_upload',
    method: 'delete',
    data,
  });
}
// VIP质检-批量提交质检结果
export function batchSaveCheckResult(data) {
  return request({
    url: '/admin/batch_save_check_result',
    method: 'put',
    data,
  });
}
// VIP质检-删除昵称
export function deleteDutyNickname(data) {
  return request({
    url: '/admin/delete_duty_nickname',
    method: 'delete',
    data,
  });
}
// VIP质检-增加昵称
export function addDutyNickname(data) {
  return request({
    url: '/admin/add_duty_nickname',
    method: 'post',
    data,
  });
}
// VIP质检-超时配置列表
export function getOverTimeSetList(data) {
  return request({
    url: '/admin/inspection_timeout_setting',
    method: 'get',
    params: data,
  });
}
// VIP质检-超时配置列表 新增超时时间设置
export function addOverTimeSetRules(data) {
  return request({
    url: '/admin/inspection_timeout_setting',
    method: 'post',
    data,
  });
}
// VIP质检-超时配置列表 修改超时时间设置
export function editOverTimeSetRules(data) {
  return request({
    url: '/admin/inspection_timeout_setting/' + data.id,
    method: 'put',
    data,
  });
}
// VIP质检-超时配置列表 根据id获取规则信息
export function getOverTimeSetRulesById(data) {
  return request({
    url: '/admin/inspection_timeout_setting/' + data.id,
    method: 'get',
  });
}
// VIP质检-超时配置列表 切换超时时间的开关
export function changeOverTimeSetRulesSwitch(data) {
  return request({
    url: '/admin/switch_inspection_status/' + data.id,
    method: 'put',
  });
}
// VIP质检-超时配置列表 删除超时时间设置
export function deleteOverTimeSetRulesById(data) {
  return request({
    url: '/admin/inspection_timeout_setting/' + data,
    method: 'delete',
  });
}
// VIP质检-已质检 修复超时状态
export function operateOverTimeSet(data) {
  return request({
    url: '/admin/calculate_inspection_timeout',
    method: 'post',
    data,
  });
}

// VIP-客服昵称 获取导入模板
export function getImportTemplate() {
  return request({
    url: '/admin/get_duty_excel',
    method: 'get',
  });
}

// VIP-客服昵称 导入excel排版表格
export function importExcel(data) {
  return request({
    url: '/admin/upload_duty_excel',
    method: 'post',
    data,
  });
}

// VIP-客服昵称 确认排班
export function serviceSure(data) {
  return request({
    url: '/admin/ensure_duty_data',
    method: 'put',
    data,
  });
}

// VIP质检-会话列表-转移出库数据
export function transferDataList(data) {
  return request({
    url: '/admin/transfer_inspection',
    method: 'put',
    data,
  });
}

// VIP质检-消除超时状态
export function eraseInspectionTimeout(data) {
  return request({
    url: '/admin/erase_inspection_timeout',
    method: 'put',
    data,
  });
}

// VIP质检-修改客服排班昵称
export function editDutyNickname(data) {
  return request({
    url: '/admin/edit_duty_nickname',
    method: 'put',
    data,
  });
}

// VIP质检-用户信息查询 列表（角色维度聚合）
// 入参：user_name / role_id / role_name / mobile / app_keys[] / server_id /
//      pay_time_start / pay_time_end / chat_app_ids[] / page / limit
// 返回：data.columns（动态列定义，受角色权限 page_user_info 控制）+ data.list + Laravel 分页字段
export function getGameUserInfo(data) {
  return request({
    url: '/admin/game_user_info',
    method: 'get',
    params: data,
  });
}

// VIP质检-用户信息查询 支付资质下金额（列表不返回，进入抽屉后按需查询）
// 入参：platform（1 玩心 2 悦玩，来自列表行）/ app_key / user_id / role_id / pay_time_start / pay_time_end
export function getGameUserInfoPayQualifications(data) {
  return request({
    url: '/admin/game_user_info_pay_qualifications',
    method: 'get',
    params: data,
  });
}

// VIP质检-用户信息查询 运营游戏树（筛选器）
export function getSameYunGameTree() {
  return request({
    url: '/admin/get_same_yun_game_tree',
    method: 'get',
  });
}

// VIP质检-用户信息查询 天网游戏列表（筛选器，控制聊天数据源 chat_app_ids）
export function getSkyNetGameOption() {
  return request({
    url: '/admin/get_sky_net_game_option',
    method: 'get',
  });
}

// VIP质检-用户信息查询 导出
// TODO: 接口对接 - URL 为占位，待服务端确认接口名 / 鉴权方式（authed 取签名 URL 或 cookie 鉴权直链）
// 入参与列表一致；推荐返回 { code: 200, data: { url: '<signed-one-time-url>' } } 前端再 window.open(url)
export function exportGameUserInfo(data) {
  return request({
    url: '/admin/export_game_user_info',
    method: 'get',
    params: data,
  });
}
